import { z } from "zod";

import { RefundPolicy } from "@calcom/lib/payment/types";

import { eventTypeAppCardZod } from "../eventTypeAppCardZod";
import { returningCustomerPricingSchema } from "../_utils/payments/returningCustomerPricingSchema";
import { paymentOptions } from "./lib/constants";

export { returningCustomerPricingSchema };
export type { ReturningCustomerPricingConfig } from "../_utils/payments/returningCustomerPricingSchema";

// Extract the payment options enum from paymentOptions
// https://stackoverflow.com/a/73825370
type PaymentOption = (typeof paymentOptions)[number]["value"];
const VALUES: [PaymentOption, ...PaymentOption[]] = [
  paymentOptions[0].value,
  ...paymentOptions.slice(1).map((option) => option.value),
];
export const paymentOptionEnum = z.enum(VALUES);

export const autoChargeNoShowFeeTimeUnitEnum = z.enum(["minutes", "hours", "days"]);

export const appDataSchema = eventTypeAppCardZod.merge(
  z.object({
    price: z.number(),
    currency: z.string(),
    paymentOption: paymentOptionEnum.optional(),
    enabled: z.boolean().optional(),
    refundPolicy: z.nativeEnum(RefundPolicy).optional(),
    refundDaysCount: z.number().optional(),
    refundCountCalendarDays: z.boolean().optional(),
    autoChargeNoShowFeeIfCancelled: z.boolean().optional(),
    autoChargeNoShowFeeTimeValue: z.number().optional(),
    autoChargeNoShowFeeTimeUnit: autoChargeNoShowFeeTimeUnitEnum.optional(),
    returningCustomerPricing: returningCustomerPricingSchema.optional(),
  })
);

export const appKeysSchema = z.object({
  client_id: z.string().startsWith("ca_").min(1),
  client_secret: z.string().startsWith("sk_").min(1),
  // public_key and webhook_secret are never consumed by any server-side code in
  // Schedly (env vars STRIPE_PRIVATE_KEY / SCHEDLY_PAYMENTS_* are used instead).
  // Making them optional prevents the admin key-save form from failing when only
  // client_id + client_secret are entered.
  public_key: z.string().startsWith("pk_").min(1).optional().or(z.literal("")),
  webhook_secret: z.string().startsWith("whsec_").min(1).optional().or(z.literal("")),
});
